import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 引入Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false

Vue.use(ElementUI)

// 导入消息提示组件
import MessageToast from '@/components/MessageToast.vue'

// 创建全局消息提示函数
const Message = {
  install(Vue) {
    // 注册全局组件
    Vue.component('MessageToast', MessageToast)
    
    // 创建全局方法
    Vue.prototype.$message = {
      success(text, duration = 3000) {
        // 创建临时容器
        const container = document.createElement('div')
        document.body.appendChild(container)
        
        // 创建组件实例
        const ToastConstructor = Vue.extend(MessageToast)
        const instance = new ToastConstructor({
          propsData: { duration }
        })
        instance.$mount(container)
        
        // 显示消息
        instance.show(text, 'success', duration)
        
        // 自动清理
        setTimeout(() => {
          instance.$destroy()
          if (instance.$el && instance.$el.parentNode) {
            instance.$el.parentNode.removeChild(instance.$el)
          }
        }, duration + 300)
      },
      
      error(text, duration = 3000) {
        const container = document.createElement('div')
        document.body.appendChild(container)
        
        const ToastConstructor = Vue.extend(MessageToast)
        const instance = new ToastConstructor({
          propsData: { duration }
        })
        instance.$mount(container)
        
        instance.show(text, 'error', duration)
        
        setTimeout(() => {
          instance.$destroy()
          if (instance.$el && instance.$el.parentNode) {
            instance.$el.parentNode.removeChild(instance.$el)
          }
        }, duration + 300)
      },
      
      warning(text, duration = 3000) {
        const container = document.createElement('div')
        document.body.appendChild(container)
        
        const ToastConstructor = Vue.extend(MessageToast)
        const instance = new ToastConstructor({
          propsData: { duration }
        })
        instance.$mount(container)
        
        instance.show(text, 'warning', duration)
        
        setTimeout(() => {
          instance.$destroy()
          if (instance.$el && instance.$el.parentNode) {
            instance.$el.parentNode.removeChild(instance.$el)
          }
        }, duration + 300)
      },
      
      info(text, duration = 3000) {
        const container = document.createElement('div')
        document.body.appendChild(container)
        
        const ToastConstructor = Vue.extend(MessageToast)
        const instance = new ToastConstructor({
          propsData: { duration }
        })
        instance.$mount(container)
        
        instance.show(text, 'info', duration)
        
        setTimeout(() => {
          instance.$destroy()
          if (instance.$el && instance.$el.parentNode) {
            instance.$el.parentNode.removeChild(instance.$el)
          }
        }, duration + 300)
      }
    }
  }
}

// 使用Message插件
Vue.use(Message)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
